import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import SEO from '../components/SEO'
import PageTransition from '../components/PageTransition'
import { FiPlus, FiUsers, FiUserPlus } from 'react-icons/fi'
import SafeIcon from '../common/SafeIcon'
import CompactGroupCard from '../components/CompactGroupCard'
import JoinGroupModal from '../components/JoinGroupModal'
import GroupsSkeleton from '../components/skeletons/GroupsSkeleton'

function Groups({ groups, loading, onJoinSuccess }) {
  const [showJoinModal, setShowJoinModal] = useState(false)

  if (loading) {
    return (
      <>
        <SEO title="My Groups | TeeSync" noindex={true} />
        <GroupsSkeleton />
      </>
    )
  }

  return (
    <>
      <SEO title="My Groups | TeeSync" noindex={true} />
      <div className="min-h-screen bg-app">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <PageTransition className="space-y-6">
            {/* Action buttons - always at the top of the page, mirroring the
                Rounds layout. Mobile: both buttons share the row via flex-1.
                Desktop: right-aligned cluster. */}
            <div className="flex flex-row items-center sm:justify-end gap-3">
              <Link
                to="/create-group"
                className="flex-1 sm:flex-none min-h-[44px] inline-flex items-center justify-center px-5 py-2.5 bg-accent text-white rounded-md hover:bg-interactive-hover transition-colors font-medium text-sm"
              >
                <SafeIcon icon={FiPlus} className="w-4 h-4 mr-2" />
                Create Group
              </Link>
              <button
                onClick={() => setShowJoinModal(true)}
                className="flex-1 sm:flex-none min-h-[44px] inline-flex items-center justify-center px-5 py-2.5 border border-border-subtle text-text-secondary rounded-md hover:bg-surface transition-colors font-medium text-sm"
              >
                <SafeIcon icon={FiUserPlus} className="w-4 h-4 mr-2" />
                Join Group
              </button>
            </div>

            {groups.length > 0 ? (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {groups.map((group) => (
                  <div key={group.id}>
                    <CompactGroupCard group={group} />
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-12 bg-card rounded-lg border border-border-subtle">
                <div className="w-16 h-16 bg-surface rounded-lg flex items-center justify-center mx-auto mb-4 border border-border-subtle">
                  <SafeIcon icon={FiUsers} className="w-8 h-8 text-text-muted" />
                </div>
                <h3 className="text-lg font-bold text-text-primary mb-2">
                  No groups yet
                </h3>
                <p className="text-sm text-text-muted">
                  Create a group or join an existing one above
                </p>
              </div>
            )}
          </PageTransition>
        </div>
      </div>

      <JoinGroupModal
        isOpen={showJoinModal}
        onClose={() => setShowJoinModal(false)}
        onJoinSuccess={onJoinSuccess}
      />
    </>
  )
}

export default Groups
